module.exports = __webpack_public_path__ + "img/thumbnail_Gharial_m_normal.181732b8.png";